import React, { useEffect, useState } from "react";
import createInstance from "../../../api/axiosinstance";
import { useSelector } from "react-redux";

const SampleOrg = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [interviewList, setInterviewList] = useState([]);
  const aiDishaApi = createInstance("DISHA");
  const organizationId = user?.organizationId;
  const [dashData, setDashData] = useState();
  const [performanceData, setPerformanceData] = useState({
    technical_knowledge: 0,
    problem_solving: 0,
    communication_skills: 0,
    culture_fit: 0,
  });

  useEffect(() => {
    getInterviewList();
    DashboardData();
    getPerformanceData();
  }, []);

  const getInterviewList = async () => {
    console.log("BEFORE API CALL");
    await aiDishaApi
      .get(`/get_Scheduled_interviews_detail?organization_id=${organizationId}`)
      .then((response) => {
        setInterviewList(response.data);
        console.log("interviews", response.data);
      })
      .catch((error) => {
        console.log("Error fetching the interviews", error);
      });
  };

  const DashboardData = async () => {
    try {
      const response = await aiDishaApi.get(
        `/Org-dashboard-values/?org_id=${organizationId}`
      );
      console.log("dash data", response.data);
      setDashData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getPerformanceData = async () => {
    try {
      const response = await aiDishaApi.get(
        `/hr_dashboard?organization_id=${organizationId || "ORGID000002"}`
      );
      console.log("performance data", response.data);
      if (
        response.data.average_graph_val &&
        response.data.average_graph_val.length > 0
      ) {
        const scores = response.data.average_graph_val[0].average_scores;
        setPerformanceData({
          technical_knowledge: scores.technical_knowledge || 0,
          problem_solving: scores.problem_solving || 0,
          communication_skills: scores.communication_skills || 0,
          culture_fit: scores.culture_fit || 0,
        });
      }
    } catch (error) {
      console.log("Error fetching performance data", error);
    }
  };

  // Calculate bar heights based on scores (scale 0-5 to 0-80px)
  const calculateBarHeight = (score) => {
    // Convert score (0-5 scale) to height (0-80px scale)
    return Math.min(80, Math.max(0, score * 16)); // 16px per point, max 80px
  };

  return (
    <div style={{ boxShadow: "-16px -9px 19px -8px rgba(0,0,0,0.75)" }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 800 600"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="a" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#f8f9fa" />
            <stop offset="50%" stop-color="#e9ecef" />
            <stop offset="100%" stop-color="#f8f9fa" />
          </linearGradient>
          <linearGradient id="g" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#4361ee" />
            <stop offset="100%" stop-color="#4361ee" stop-opacity=".6" />
          </linearGradient>
          <linearGradient id="h" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#3a86ff" stop-opacity=".9" />
            <stop offset="100%" stop-color="#3a86ff" stop-opacity=".7" />
          </linearGradient>
          <linearGradient id="i" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#3a86ff" stop-opacity=".8" />
            <stop offset="100%" stop-color="#3a86ff" stop-opacity=".6" />
          </linearGradient>
          <linearGradient id="j" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#3a86ff" stop-opacity=".7" />
            <stop offset="100%" stop-color="#3a86ff" stop-opacity=".5" />
          </linearGradient>
          <linearGradient id="k" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#3a86ff" stop-opacity=".6" />
            <stop offset="100%" stop-color="#3a86ff" stop-opacity=".4" />
          </linearGradient>
          <linearGradient id="l" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#3a86ff" stop-opacity=".5" />
            <stop offset="100%" stop-color="#3a86ff" stop-opacity=".3" />
          </linearGradient>
          <linearGradient id="m" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#3a86ff" stop-opacity=".4" />
            <stop offset="100%" stop-color="#3a86ff" stop-opacity=".2" />
          </linearGradient>
          <filter id="b" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
            <feColorMatrix
              in="blur"
              values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 12 -6"
              result="glassmorphism"
            />
            <feComposite
              in="SourceGraphic"
              in2="glassmorphism"
              operator="atop"
            />
          </filter>
          <filter id="c" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feFlood flood-color="#4361ee" flood-opacity=".3" result="glow" />
            <feComposite
              in="glow"
              in2="blur"
              operator="in"
              result="coloredBlur"
            />
            <feComposite in="SourceGraphic" in2="coloredBlur" />
          </filter>
          <filter id="e" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feFlood flood-color="#06d6a0" flood-opacity=".3" result="glow" />
            <feComposite
              in="glow"
              in2="blur"
              operator="in"
              result="coloredBlur"
            />
            <feComposite in="SourceGraphic" in2="coloredBlur" />
          </filter>
          <filter id="d" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feFlood flood-color="#3a86ff" flood-opacity=".3" result="glow" />
            <feComposite
              in="glow"
              in2="blur"
              operator="in"
              result="coloredBlur"
            />
            <feComposite in="SourceGraphic" in2="coloredBlur" />
          </filter>
          <filter id="f" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feFlood flood-color="#f9c74f" flood-opacity=".3" result="glow" />
            <feComposite
              in="glow"
              in2="blur"
              operator="in"
              result="coloredBlur"
            />
            <feComposite in="SourceGraphic" in2="coloredBlur" />
          </filter>
        </defs>
        <path fill="url(#a)" d="M0 0h800v600H0z" />

        <g transform="translate(40 30)">
          <rect
            width="170"
            height="100"
            rx="10"
            ry="10"
            fill="rgba(255, 255, 255, 0.8)"
            filter="url(#b)"
            stroke="#4361ee"
            stroke-opacity=".3"
          />
          <circle cx="30" cy="30" r="15" fill="#4361ee80" filter="url(#c)" />
          <text
            x="30"
            y="35"
            font-family="Arial"
            font-size="16"
            fill="#4361ee"
            text-anchor="middle"
          >
            👤
          </text>
          <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
            Total Interviews
          </text>
          <text
            x="70"
            y="55"
            font-family="Arial"
            font-size="20"
            font-weight="bold"
            fill="#000"
          >
            {interviewList ? interviewList.length : 0}
          </text>
          <text x="70" y="75" font-family="Arial" font-size="12" fill="#06d6a0">
            ↑ +12%
          </text>
        </g>
        <g transform="translate(230 30)">
          <rect
            width="170"
            height="100"
            rx="10"
            ry="10"
            fill="rgba(255, 255, 255, 0.8)"
            filter="url(#b)"
            stroke="#3a86ff"
            stroke-opacity=".3"
          />
          <circle cx="30" cy="30" r="15" fill="#3a86ff80" filter="url(#d)" />
          <text
            x="30"
            y="35"
            font-family="Arial"
            font-size="16"
            fill="#3a86ff"
            text-anchor="middle"
          >
            X
          </text>
          <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
            Cancelled
          </text>
          <text
            x="70"
            y="55"
            font-family="Arial"
            font-size="20"
            font-weight="bold"
            fill="#000"
          >
            {dashData?.Cancelled_interviews || 0}
          </text>
          <text x="70" y="75" font-family="Arial" font-size="12" fill="#06d6a0">
            ↑ +5%
          </text>
        </g>
        <g transform="translate(420 30)">
          <rect
            width="170"
            height="100"
            rx="10"
            ry="10"
            fill="rgba(255, 255, 255, 0.8)"
            filter="url(#b)"
            stroke="#06d6a0"
            stroke-opacity=".3"
          />
          <circle cx="30" cy="30" r="15" fill="#06d6a080" filter="url(#e)" />
          <text
            x="30"
            y="35"
            font-family="Arial"
            font-size="16"
            fill="#06d6a0"
            text-anchor="middle"
          >
            📅
          </text>
          <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
            Scheduled
          </text>
          <text
            x="70"
            y="55"
            font-family="Arial"
            font-size="20"
            font-weight="bold"
            fill="#000"
          >
            {dashData?.scheduled || 0}
          </text>
          <text x="70" y="75" font-family="Arial" font-size="12" fill="#06d6a0">
            ↑ +8%
          </text>
        </g>
        <g transform="translate(610 30)">
          <rect
            width="180"
            height="100"
            rx="10"
            ry="10"
            fill="rgba(255, 255, 255, 0.8)"
            filter="url(#b)"
            stroke="#f9c74f"
            stroke-opacity=".3"
          />
          <circle cx="30" cy="30" r="15" fill="#f9c74f80" filter="url(#f)" />
          <text
            x="30"
            y="35"
            font-family="Arial"
            font-size="16"
            fill="#f9c74f"
            text-anchor="middle"
          >
            🔁
          </text>
          <text x="60" y="25" font-family="Arial" font-size="12" fill="#495057">
            Resheduled
          </text>
          <text
            x="70"
            y="55"
            font-family="Arial"
            font-size="20"
            font-weight="bold"
            fill="#000"
          >
            {dashData?.Rescheduled_interviews || 0}
          </text>
          <text x="70" y="75" font-family="Arial" font-size="12" fill="#ef476f">
            ↓ -3%
          </text>
        </g>
        <g transform="translate(40 150)">
          <rect
            width="360"
            height="180"
            rx="10"
            ry="10"
            fill="rgba(255, 255, 255, 0.8)"
            filter="url(#b)"
            stroke="#4361ee"
            stroke-opacity=".3"
          />
          <circle cx="30" cy="30" r="15" fill="#4361ee80" filter="url(#c)" />
          <text
            x="30"
            y="35"
            font-family="Arial"
            font-size="14"
            fill="#4361ee"
            text-anchor="middle"
          >
            📊
          </text>
          <text
            x="60"
            y="35"
            font-family="Arial"
            font-size="14"
            font-weight="bold"
            fill="#000"
          >
            Interview Performance
          </text>
          <path stroke="#495057" d="M50 150h260M50 150V70" />

          {/* Updated bars with actual API data */}
          <rect
            x="70"
            y={150 - calculateBarHeight(performanceData.technical_knowledge)}
            width="30"
            height={calculateBarHeight(performanceData.technical_knowledge)}
            rx="5"
            ry="5"
            fill="url(#g)"
          />
          <rect
            x="120"
            y={150 - calculateBarHeight(performanceData.communication_skills)}
            width="30"
            height={calculateBarHeight(performanceData.communication_skills)}
            rx="5"
            ry="5"
            fill="url(#g)"
          />
          <rect
            x="170"
            y={150 - calculateBarHeight(performanceData.problem_solving)}
            width="30"
            height={calculateBarHeight(performanceData.problem_solving)}
            rx="5"
            ry="5"
            fill="url(#g)"
          />
          <rect
            x="220"
            y={150 - calculateBarHeight(performanceData.culture_fit)}
            width="30"
            height={calculateBarHeight(performanceData.culture_fit)}
            rx="5"
            ry="5"
            fill="url(#g)"
          />

          {/* Score labels above bars */}
          <text
            x="85"
            y={145 - calculateBarHeight(performanceData.technical_knowledge)}
            font-family="Arial"
            font-size="10"
            fill="#000"
            text-anchor="middle"
          >
            {performanceData.technical_knowledge.toFixed(1)}
          </text>
          <text
            x="135"
            y={145 - calculateBarHeight(performanceData.communication_skills)}
            font-family="Arial"
            font-size="10"
            fill="#000"
            text-anchor="middle"
          >
            {performanceData.communication_skills.toFixed(1)}
          </text>
          <text
            x="185"
            y={145 - calculateBarHeight(performanceData.problem_solving)}
            font-family="Arial"
            font-size="10"
            fill="#000"
            text-anchor="middle"
          >
            {performanceData.problem_solving.toFixed(1)}
          </text>
          <text
            x="235"
            y={145 - calculateBarHeight(performanceData.culture_fit)}
            font-family="Arial"
            font-size="10"
            fill="#000"
            text-anchor="middle"
          >
            {performanceData.culture_fit.toFixed(1)}
          </text>

          <text
            x="85"
            y="165"
            font-family="Arial"
            font-size="10"
            fill="#495057"
            text-anchor="middle"
          >
            Tech
          </text>
          <text
            x="135"
            y="165"
            font-family="Arial"
            font-size="10"
            fill="#495057"
            text-anchor="middle"
          >
            Comm
          </text>
          <text
            x="185"
            y="165"
            font-family="Arial"
            font-size="10"
            fill="#495057"
            text-anchor="middle"
          >
            Problem
          </text>
          <text
            x="235"
            y="165"
            font-family="Arial"
            font-size="10"
            fill="#495057"
            text-anchor="middle"
          >
            Culture
          </text>

          {/* Y-axis labels */}
          <text
            x="45"
            y="70"
            font-family="Arial"
            font-size="8"
            fill="#495057"
            text-anchor="end"
          >
            5
          </text>
          <text
            x="45"
            y="90"
            font-family="Arial"
            font-size="8"
            fill="#495057"
            text-anchor="end"
          >
            4
          </text>
          <text
            x="45"
            y="110"
            font-family="Arial"
            font-size="8"
            fill="#495057"
            text-anchor="end"
          >
            3
          </text>
          <text
            x="45"
            y="130"
            font-family="Arial"
            font-size="8"
            fill="#495057"
            text-anchor="end"
          >
            2
          </text>
          <text
            x="45"
            y="150"
            font-family="Arial"
            font-size="8"
            fill="#495057"
            text-anchor="end"
          >
            1
          </text>
        </g>
        <g transform="translate(420 150)">
          <rect
            width="360"
            height="180"
            rx="10"
            ry="10"
            fill="rgba(255, 255, 255, 0.8)"
            filter="url(#b)"
            stroke="#06d6a0"
            stroke-opacity=".3"
          />
          <circle cx="30" cy="30" r="15" fill="#06d6a080" filter="url(#e)" />
          <text
            x="30"
            y="35"
            font-family="Arial"
            font-size="14"
            fill="#06d6a0"
            text-anchor="middle"
          >
            📈
          </text>
          <text
            x="60"
            y="35"
            font-family="Arial"
            font-size="14"
            font-weight="bold"
            fill="#000"
          >
            Interview Count panel wise
          </text>
          <g transform="translate(180 100)">
            {dashData &&
              (() => {
                const total =
                  (dashData.total_tech_panel_no || 0) +
                  (dashData.total_hr_no || 0) +
                  (dashData.total_manager_no || 0);
                if (total === 0) return null; // Handle zero total case

                const toRadians = (degrees) => (degrees * Math.PI) / 180;
                const techAngle = (dashData.total_tech_panel_no / total) * 360;
                const hrAngle = (dashData.total_hr_no / total) * 360;
                const managerAngle = (dashData.total_manager_no / total) * 360;

                const techEnd = {
                  x: 50 * Math.cos(toRadians(techAngle)),
                  y: 50 * Math.sin(toRadians(techAngle)),
                };
                const hrEnd = {
                  x: 50 * Math.cos(toRadians(techAngle + hrAngle)),
                  y: 50 * Math.sin(toRadians(techAngle + hrAngle)),
                };
                const managerEnd = {
                  x:
                    50 *
                    Math.cos(toRadians(techAngle + hrAngle + managerAngle)),
                  y:
                    50 *
                    Math.sin(toRadians(techAngle + hrAngle + managerAngle)),
                };

                const techLargeArc = techAngle > 180 ? 1 : 0;
                const hrLargeArc = hrAngle > 180 ? 1 : 0;
                const managerLargeArc = managerAngle > 180 ? 1 : 0;

                const techPath = `M 0 0 L 50 0 A 50 50 0 ${techLargeArc} 1 ${techEnd.x.toFixed(
                  2
                )} ${techEnd.y.toFixed(2)} z`;
                const hrPath = `M 0 0 L ${techEnd.x.toFixed(
                  2
                )} ${techEnd.y.toFixed(
                  2
                )} A 50 50 0 ${hrLargeArc} 1 ${hrEnd.x.toFixed(
                  2
                )} ${hrEnd.y.toFixed(2)} z`;
                const managerPath = `M 0 0 L ${hrEnd.x.toFixed(
                  2
                )} ${hrEnd.y.toFixed(
                  2
                )} A 50 50 0 ${managerLargeArc} 1 ${managerEnd.x.toFixed(
                  2
                )} ${managerEnd.y.toFixed(2)} z`;

                return (
                  <>
                    <path d={techPath} fill="#4361ee" />
                    <path d={hrPath} fill="#3a86ff" />
                    <path d={managerPath} fill="#06d6a0" />
                    <circle r="25" fill="rgba(255, 255, 255, 0.7)" />
                  </>
                );
              })()}
          </g>
          <path fill="#4361ee" d="M50 162h8v10H50z" />
          <text
            x="60"
            y="170"
            font-family="Arial"
            font-size="10"
            fill="#495057"
          >
            Tech panel[{dashData?.total_tech_panel_no || 0 }]
          </text>
          <path fill="#06d6a0" d="M140 162h8v10h-8z" />
          <text
            x="150"
            y="170"
            font-family="Arial"
            font-size="10"
            fill="#495057"
          >
            Managerial[{dashData?.total_manager_no||0}]
          </text>
          <path fill="#3a86ff" d="M235 162h8v10h-8z" />
          <text
            x="245"
            y="170"
            font-family="Arial"
            font-size="10"
            fill="#495057"
          >
            HR[{dashData?.total_hr_no||0}]
          </text>
        </g>
        <g transform="translate(40 350)">
          <rect
            width="730"
            height="240"
            rx="10"
            ry="10"
            fill="rgba(255, 255, 255, 0.8)"
            filter="url(#b)"
            stroke="#3a86ff"
            stroke-opacity=".3"
          />
          <circle cx="30" cy="30" r="15" fill="#3a86ff80" filter="url(#d)" />
          <text
            x="30"
            y="35"
            font-family="Arial"
            font-size="14"
            fill="#3a86ff"
            text-anchor="middle"
          >
            🔍
          </text>
          <text
            x="60"
            y="35"
            font-family="Arial"
            font-size="14"
            font-weight="bold"
            fill="#000"
          >
            Recruitment Funnel
          </text>

          {/* New Funnel Visualization with Reduced Spacing */}
          <g transform="translate(365 70)">
            <path
              d="M-200 0 L200 0 L150 30 L-150 30 Z"
              fill="url(#h)"
              stroke="#3a86ff"
              stroke-width="1"
            />
            <path
              d="M-150 30 L150 30 L100 60 L-100 60 Z"
              fill="url(#i)"
              stroke="#3a86ff"
              stroke-width="1"
            />
            <path
              d="M-100 60 L100 60 L50 90 L-50 90 Z"
              fill="url(#j)"
              stroke="#3a86ff"
              stroke-width="1"
            />
            <path
              d="M-50 90 L50 90 L20 120 L-20 120 Z"
              fill="url(#k)"
              stroke="#3a86ff"
              stroke-width="1"
            />
            <path
              d="M-20 120 L20 120 L10 150 L-10 150 Z"
              fill="#006400"
              stroke="#006400"
              stroke-width="1"
            />

            <text
              x="-225"
              y="0"
              font-family="Arial"
              font-size="12"
              font-weight="bold"
              fill="#000"
              text-anchor="end"
            >
              Applications ({dashData?.total_applications || 0})
            </text>
            <path stroke="#495057" d="M-225 0 L-200 0" />

            <text
              x="-225"
              y="30"
              font-family="Arial"
              font-size="12"
              font-weight="bold"
              fill="#8B4513"
              text-anchor="end"
            >
              First Round ({dashData?.first_round || 0})
            </text>
            <path stroke="#495057" d="M-225 30 L-150 30" />

            <text
              x="-225"
              y="60"
              font-family="Arial"
              font-size="12"
              font-weight="bold"
              fill="#000"
              text-anchor="end"
            >
              HR Round ({dashData?.hr_round || 0})
            </text>
            <path stroke="#495057" d="M-225 60 L-100 60" />

            <text
              x="-225"
              y="90"
              font-family="Arial"
              font-size="12"
              font-weight="bold"
              fill="#8B4513"
              text-anchor="end"
            >
              Manager Round ({dashData?.manager_round || 0})
            </text>
            <path stroke="#495057" d="M-225 90 L-50 90" />

            <text
              x="225"
              y="135"
              font-family="Arial"
              font-size="12"
              font-weight="bold"
              fill="#006400"
              text-anchor="start"
            >
              Hired ({dashData?.total_hire || 0})
            </text>
            <path stroke="#495057" d="M20 135 L220 135" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default SampleOrg;
